import {
  CLEAR_BED,
  CLEAR_BED_TYPES,
  CLEAR_BED_FLOOR,
  CREATEFLOOR,
  GETFLOOR,
  UPDATEFLOOR,
  DELETEFLOOR,
  CREATEBEDGROUP,
  GETBEDGROUP,
  UPDATEBEDGROUP,
  DELETEBEDGROUP,
  CREATEBEDTYPE,
  GETBEDTYPE,
  UPDATEBEDTYPE,
  DELETEBEDTYPE,
  CREATEBED,
  GETBED,
  UPDATEBED,
  DELETEBED,
  CREATECOUNTER,
  GETCOUNTER,
  GETCOUNTERBYID,
  UPDATECOUNTER,
  DELETECOUNTER,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case CREATEFLOOR:
      return {
        ...state,
        floorSaveStatus: action.payload.success,
      };
    case GETFLOOR:
      return {
        ...state,
        floorList: action.payload.data,
      };
    case CLEAR_BED_FLOOR:
      return { ...state, floorList: [] };
    case CLEAR_BED:
      return { ...state, bedList: [] };
    case CLEAR_BED_TYPES:
      return { ...state, bedtypeList: [] };

    case UPDATEFLOOR:
      return {
        ...state,
        floorUpdateStatus: action.payload.success,
      };

    case DELETEFLOOR:
      return {
        ...state,
        floorDeleteStatus: action.payload.success,
      };
    case CREATEBEDGROUP:
      return {
        ...state,
        bedgroupSaveStatus: action.payload.success,
      };
    case GETBEDGROUP:
      return {
        ...state,
        bedgroupList: action.payload.data,
      };
    case UPDATEBEDGROUP:
      return {
        ...state,
        bedgroupUpdateStatus: action.payload.success,
      };

    case DELETEBEDGROUP:
      return {
        ...state,
        bedgroupDeleteStatus: action.payload.success,
      };
    case CREATEBEDTYPE:
      return {
        ...state,
        bedtypeSaveStatus: action.payload.success,
      };
    case GETBEDTYPE:
      return {
        ...state,
        bedtypeList: action.payload.data,
      };
    case UPDATEBEDTYPE:
      return {
        ...state,
        bedtypeUpdateStatus: action.payload.success,
      };

    case DELETEBEDTYPE:
      return {
        ...state,
        bedtypeDeleteStatus: action.payload.success,
      };
    case CREATEBED:
      return {
        ...state,
        bedSaveStatus: action.payload.success,
      };
    case GETBED:
      return {
        ...state,
        bedList: action.payload.data,
      };
    case UPDATEBED:
      return {
        ...state,
        bedUpdateStatus: action.payload.success,
      };

    case DELETEBED:
      return {
        ...state,
        bedDeleteStatus: action.payload.success,
      };
    case CREATECOUNTER:
      return {
        ...state,
        counterSaveStatus: action.payload.success,
      };

    case GETCOUNTER:
      return {
        ...state,
        counterList: action.payload.data,
      };

    case GETCOUNTERBYID:
      return {
        ...state,
        counterDetail: action.payload.data,
      };

    case UPDATECOUNTER:
      return {
        ...state,
        counterUpdateStatus: action.payload.success,
      };

    case DELETECOUNTER:
      return {
        ...state,
        counterDeleteStatus: action.payload.success,
      };
    default:
      return state;
  }
}
